import React from 'react'

const ShopCategoriesSkelton = (): JSX.Element => {
  return (
    <div className="w-[96px] flex-shrink-0">
      {/* Image */}
      <div className="mx-auto h-[80px] w-[80px] overflow-hidden rounded-[20px] bg-[#F4F4F5] relative">
        <div className="absolute inset-0 animate-pulse bg-gray-200" />
      </div>

      {/* Text */}
      <div className="mt-3 flex flex-col items-center gap-2">
        <div className="h-4 w-[72px] animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-[56px] animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  )
}

export default ShopCategoriesSkelton
